import React from 'react';
import BgImage from '../../images/about/about-5/bg-shape.png'

const about6 = (props) => {
    return (
        <section id="about" className={"" + props.hclass}
            style={{ backgroundImage: `url(${BgImage})` }}>
            <div className="about-wrap">
                <div className="content">
                    <div className="title fade_bottom">
                        <h2>Welcome ToBliize</h2>
                    </div>
                    <p className="fade_bottom">We specializes in crafting spaces that inspire and endure. Blaze pushes the
                        boundaries, transforming bold concept into architectural masterpieces, ensures precision and
                        efficiency.</p>
                </div>
            </div>
        </section>
    );
};

export default about6;